<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Report Card Publish Setting">
      <v-card flat class="px-2">
        <v-form @submit.prevent="save" class="px-6">
          <v-row>
            <v-col cols="12" md="6">
              <v-select @change="changeSections()" v-model="selectedClassID" :items="classList" item-text="name" item-value="id" label="Class"></v-select>
            </v-col>

            <v-col cols="12" md="6">
              <v-select v-model="selectedTerm" :items="terms" item-text="customName" item-value="id" label="Term"></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          ></v-text-field>
           <v-btn v-on:click="saveData()" v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
              <v-icon left>mdi-content-save</v-icon>
              Save
            </v-btn>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table
          v-if="tableData.length"
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="tableData"
          :search.sync="search"
        >
          <template v-slot:item.isReportView="{ item }">
            <v-simple-checkbox v-model="item.isReportView"></v-simple-checkbox>
          </template>
          <template v-slot:item.date="{ item }">
            <custom-date-picker v-model.trim="item.date" :minToDate="minDate" />
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn v-if="item.date && item.gradeReportPublishDate" class="px-2 ml-1 ma-1" color="primary" min-width="0" small @click="sendEmail(item)">
              <v-icon small> mdi-email-send-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import Utils from '@/utils'
import CustomDatePicker from '@/components/template/CustomDatePicker'
export default {
  components: { MaterialCard, CustomDatePicker, VCardComponent },
  name: 'reportPublish',

  data () {
    return {
      isLoading: false,
      tableData: [],
      menu: false,
      classList: [],
      sectionList: [],
      classWiseSections: [],
      franchiseeID: '',
      academicYearID: '',
      selectedClassID: '',
      selectedClassName: '',
      selectedTerm: '',
      terms: [],
      search: '',
      lock: false,
      minDate: null,
      headers: [
        { text: 'Class', value: 'studentClass.name' },
        { text: 'Section', value: 'name' },
        { text: 'View Report', value: 'isReportView', align: 'center' },
        { text: 'Parent View Date', value: 'date', align: 'center' },
        { text: 'Send mail', value: 'actions', align: 'center' }
      ],
      isWrite: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID: async function (val) {
      this.tableData = []
      if (this.selectedClassID) {
        await this.getTerms()
      }
    },
    selectedTerm: async function (val) {
      this.tableData = []
      await this.getData()
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.minDate = moment().format('YYYY-MM-DD')
  },
  methods: {
    sendEmail: async function (item) {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/grade-module/report/publish/mail?franchiseeID=${this.franchiseeID}&classID=${this.selectedClassID}&sectionID=${item.id}&academicTermsDateMapID=${item.gradeReportPublishDate.academicTermsDateMapID}&date=${item.date}`
        )
        this.okMsg(res.data.length > 0 ? res.data[0] : 'Mail sent successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    saveData: async function () {
      let finalArr = []
      this.tableData.map(a => {
        if (a.date) {
          finalArr.push({
            sectionID: a.id,
            date: a.date,
            parentViewDate: a.date,
            isReportView: a.isReportView,
            isActive: true
          })
        }
      })
      if (finalArr.length < 1) {
        this.errMsg('Kindly select all fields to save!')
        return false
      }

      let formData = {
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        academicYearID: this.academicYearID,
        academicTermsDateMapID: this.selectedTerm,
        gradePublishSettingData: finalArr
      }

      try {
        this.isLoading = true
        await http.post(`${CONSTANTS.API_URL}/api/grade-module/report/publish/setting`, formData)
        this.okMsg('Record added successfully!')
        await this.getData()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(`${CONSTANTS.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`)
        const data = response.data
        this.classList = data
        this.sectionList = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    changeSections: async function () {
      let r = this.classList.filter(a => {
        return a.id === this.selectedClassID ? a.name : false
      })
      this.selectedClassName = r[0].name
      let sectionarray = this.sectionList.find(obj => obj.id === this.selectedClassID)
      if (sectionarray) {
        this.classWiseSections = sectionarray.sections
      } else {
        this.classWiseSections = []
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        this.tableData = []

        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }

        this.selectedTerm = ''
        this.selectedClassID = ''
        this.selectedClassName = ''
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
          if (this.selectedClassID) {
            await this.getTerms()
            await this.getData()
          }
        }
        this.inProgress = false
      }
    },
    getTerms: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${CONSTANTS.API_URL}/api/grade-module/academic-terms/date/map?classID=${this.selectedClassID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`
        )

        this.selectedTerm = ''
        this.terms = data
        let t = this.terms.map(a => {
          a.toDate = moment(a.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.customName = `${a.academicTerm.name} (${a.toDate}/${a.fromDate})`
          return a
        })
        this.terms = t
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getData: async function () {
      if (this.selectedClassID && this.selectedTerm) {
        try {
          this.isLoading = true
          let res = await http.get(
            `${CONSTANTS.API_URL}/api/grade-module/report/publish/setting?classID=${this.selectedClassID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&academicTermsDateMapID=${this.selectedTerm}`
          )
          this.tableData = _.map(res.data, item => {
            item.isReportView = item.gradeReportPublishDate ? item.gradeReportPublishDate.isReportView : false
            item.date = item.gradeReportPublishDate ? moment(item.gradeReportPublishDate.date).format('YYYY-MM-DD') : null
            return item
          })
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
          this.isLoading = false
        }
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
